const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const FORMATO = /^[A-Z0-9]{12}[0-9]{2}$/;

export function normalizarCnpj(entrada) {
   return entrada.replace(/[./-]/g, "").trim().toUpperCase();
}

function calcularDv(caracteres, pesos) {
   // charCodeAt(0) - 48 é a conversão oficial: dígitos mantêm o valor
   // numérico, letras maiúsculas assumem valores de 17 ('A') a 42 ('Z').
   const soma = [...caracteres].reduce(
      (acc, c, i) => acc + (c.charCodeAt(0) - 48) * pesos[i],
      0,
   );
   const resto = soma % 11;
   return resto < 2 ? 0 : 11 - resto;
}

export function isValidCNPJ(entrada) {
   const cnpj = normalizarCnpj(entrada ?? "");
   if (!FORMATO.test(cnpj)) return false;

   // Sequências repetidas fecham o módulo 11. Rejeita por regra, não por
   // lista fixa: com letras no domínio, a lista clássica ficou incompleta.
   if ([...cnpj.slice(0, 12)].every((c) => c === cnpj[0])) return false;

   const dv1 = calcularDv(cnpj.slice(0, 12), PESOS_DV1);
   const dv2 = calcularDv(cnpj.slice(0, 12) + String(dv1), PESOS_DV2);

   return cnpj[12] === String(dv1) && cnpj[13] === String(dv2);
}